// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__RFkos","patient":"styles_patient__NUPLi","cutInfo":"styles_cutInfo__qYzkO","separator":"styles_separator__haZoL"};